import { useRef, useEffect } from "react";
import { useStickyTourStore } from "../../stores/stickyTourStore";
import classNames from "classnames";
// @ts-ignore
import styled from "styled-components/macro";
import { AnchorIds } from "./TourTypes";

const StickyNoteAnchorContainer = styled.div`
  position: absolute !important;
  z-index: 110000;
`;

export default function StickyNoteAnchor({ anchorId }: { anchorId: AnchorIds }) {
  const ref = useRef(null);
  const setAnchors = useStickyTourStore((state) => state.setAnchors);
  const removeAnchor = useStickyTourStore((state) => state.removeAnchor);
  const showAnchors = useStickyTourStore((state) => state.showAnchors);

  useEffect(() => {
    setAnchors(anchorId, ref);
    return () => {
      removeAnchor(anchorId);
    };
  }, [anchorId, ref, setAnchors, removeAnchor]);

  return (
    <StickyNoteAnchorContainer
      className={classNames(
        "absolute z-[10000]",
        {
          "w-[10px] h-[10px] bg-blue-500 group": showAnchors,
          "w-0 h-0": !showAnchors,
        },
        showAnchors ? `ANCHOR-${anchorId}` : null
      )}
      ref={ref}
    >
      {showAnchors && anchorId && (
        <span
          className={classNames(
            "pointer-events-none select-none",
            "absolute",
            "px-2 py-0.5 rounded bg-black text-white text-xs font-mono opacity-0 group-hover:opacity-100 transition-opacity duration-150",
            "shadow z-[10002]"
          )}
          style={{ whiteSpace: "nowrap" }}
        >
          {anchorId}
        </span>
      )}
    </StickyNoteAnchorContainer>
  );
}
